export const isProd = (): boolean => {
    // BUILD_ENV was defined by Webpack Define Plugin.
    // It is `production` at prod env and `test`
    // at dev env.
    return process.env.BUILD_ENV === 'production';
};

// `isDev` might be a better way to judge if it's prod
// because
const isTestFn = (): boolean => {
    return process.env.BUILD_ENV === 'test';
};

export const isTest = isTestFn();



// WEBPACK FOOTER //
// ./src/utils/isProd.ts